export enum DataTableSortEnum {
    /**
     * Sort enum for ascending order
     */
    ASC = 'ASC',

    /**
     * Sort enum for descending order
     */
    DESC = 'DESC',
}

export enum DataTableSortFloatEnum {
    /**
     * Sort enum for float columns
     */
    ASC = 1,

    /**
     * Sort enum for float columns
     */
    DESC = -1,
}

/**
 * @type DataTableSortType
 * @description Type for sort type
 */
export type DataTableSortType = 'ASC' | 'DESC';